import { BarChart, Bar, XAxis, YAxis } from "recharts";

interface BarChartProps {
  data: {
    label: string;
    number: number;
    fill: string;
  }[];
}

const BarGraph = ({ data }: BarChartProps) => {
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <BarChart width={400} height={300} data={data}>
        <XAxis dataKey="label" />
        <YAxis />
        <Bar dataKey="number" />
      </BarChart>
    </div>
  );
};

export default BarGraph;
